import React, { useState } from "react";
// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import ReactBSAlert from "react-bootstrap-sweetalert";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
// import dateFormat from "dateformat";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import FormControl from "@material-ui/core/FormControl";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import DatePicker from "react-datepicker";
// @material-ui/lab components
// @material-ui/icons components
// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import { useAsyncEffect } from "use-async-effect";

import {
  getOrders,
  getAllDelayedOrders,
  bulkAssignLaundries,
  getAllActiveLaundries,
  bulkAssignDriver,
  getAllActiveDrivers,
  getAllStatus,
  bulkUpdateOrderStatus,
  getAllServices,
  getPendingActionOrdersCount,
  getAllSlots,
  bulkUpdateOrderSlots
} from "../../network/ApiAxios";
import {
  redirectToLogout,
  parseWashingFeatures,
  zeroFill, numericSortFunc, dateSortFunc, slotDateSortFunc
} from "common/SharedFn";
import { Receipt } from "@material-ui/icons";
import { getOrderStatusCode } from "common/SharedFn";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const createHistory = require("history").createBrowserHistory;

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPage: 50,
  sizePerPageRenderer: ({ onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="500">500</option>
            <option value="1000">1000</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  ),
});

const { SearchBar } = Search;

const { ExportCSVButton } = CSVExport;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const OrdersTable = (props) => {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const [alert, setAlert] = React.useState(false);
  const componentRef = React.useRef(null);
  const [data, setData] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [slots, setSlots] = useState([]);
  const [laundries, setLaundries] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [servicesList, setServicesList] = useState([]);
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [success, setSuccess] = React.useState(false);
  const [showError, setShowError] = React.useState(false);
  const [filterBy, setFilterBy] = useState(0);
  const [activeOnly, setActiveOnly] = useState(1);
  const [pendingOrdersCount, setPendingOrdersCount] = useState(0);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [id, setId] = useState();
  const [assignLaundryModal, setAssignLaundryModal] = useState(false);
  const [assignedLaundryId, setAssignedLaundryId] = useState(0);
  const [executeAssignLaundry, setExecuteAssignLaundry] = useState(false);
  const [assignDriverModal, setAssignDriverModal] = useState(false);
  const [assignDriverType, setAssignDriverType] = useState(1);
  const [updateStatusModal, setUpdateStatusModal] = useState(false);
  const [updateSlotsModal, setUpdateSlotsModal] = useState(false);
  const [updateSlotsType, setUpdateSlotsType] = useState(0);
  const [assignedDriverId, setAssignedDriverId] = useState(0);
  const [executeAssignDriver, setExecuteAssignDriver] = useState(false);
  const [executeStatusUpdate, setExecuteStatusUpdate] = useState(false);
  const [executeSlotsUpdate, setExecuteSlotsUpdate] = useState(false);
  const [forceRefresh, setForceRefresh] = useState(false);
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [newStatus, setNewStatus] = useState(1);
  const [refundToWallet, setRefundToWallet] = useState(1);
  const [ids, setIds] = useState([]);
  const [subscriptionId, setSubscriptionId] = useState();
  const [isSubscription, setIsSubscription] = useState(0);
  const [selectedCount, setSelectedCount] = useState(0);
  const [pickupDate, setPickupDate] = useState();
  const [pickupTimeslot, setPickupTimeslot] = useState(0);
  const [dropoffDate, setDropoffDate] = useState();
  const [dropoffTimeslot, setDropoffTimeslot] = useState(0);
  const [delayedOrders, setDelayedOrders] = useState([]);
  var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var columns = [];

  const rowStyle = (row, rowIndex) => {
    // Check if order is in delayed orders list
    

    // Light red for orders with dropoff change or negative wallet balance
    if ((row.requireDropoffChange != null && row.requireDropoffChange === 1) || (row.negativeWalletBalanceFlag != null && row.negativeWalletBalanceFlag === 1)) {
      return { backgroundColor: "#FFCCCB" };
    }

    // Light red for delayed orders
    if (isDelayedOrder(row.id, getOrderStatusCode(row.status))) {
      return { backgroundColor: "#FDF6C0" };
    }

    return {};
  };

  const isDelayedOrder = (orderId, orderStatus) => {
      // Get all delay entries for this order
      const relatedDelays = delayedOrders.filter(d => d.orderId === orderId);
      if (relatedDelays.length === 0) {
        return false;
      }

      // Get the last (latest) delay entry
      const latestDelay = relatedDelays[relatedDelays.length - 1];
      const type = latestDelay.type;

      // Apply type-based rules to exit if it's no longer delayed
      if (
        (type === 0 && orderStatus >= 3) ||
        (type === 1 && orderStatus >= 7) ||
        (type === 2 && orderStatus >= 5)
      ) {
        return false;
      }

      return true;
    };


  const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    style: { backgroundColor: "#c8e6c9" },
    onSelect: (row, isSelect, rowIndex, e) => {
      if (isSelect) {
        ids.push(row.id);
      } else {
        var index = ids.indexOf(row.id);
        if (index !== -1) {
          ids.splice(index, 1);
        }
      }
      setSelectedCount(ids.length);
    },
    onSelectAll: (isSelect, rows, e) => {
      if (isSelect) {
        for (var i = 0; i < rows.length; i++) {
          ids.push(rows[i].id);
        }
      } else {
        for (var i = 0; i < rows.length; i++) {
          var index = ids.indexOf(rows[i].id);
          if (index !== -1) {
            ids.splice(index, 1);
          }
        }
      }
      setSelectedCount(ids.length);
    },
  };

  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
    setTimeout(function () {
      setSuccess(false);
    }, 3000);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const accessOrderPage = (id) => {
    let history = createHistory();
    history.push("/admin/orders/" + id);
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };

  const accessBagUpdatesPage = () => {
    let history = createHistory();
    history.push("/admin/orders/bagUpdates");
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };


  const accessBagWeightReportPage = () => {
    let history = createHistory();
    history.push("/admin/orders/report/weight");
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };

  const clearCurrentRecord = () => {
    setAssignedDriverId(0);
    setAssignedLaundryId(0);
    setNewStatus(1);
    setRefundToWallet(1);
    setId();
  };

  const fetchOrders = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    setData([]);
    try {
      const responsePendingOrdersCount = await getPendingActionOrdersCount();
      const response = await getOrders(startDate, endDate, filterBy, activeOnly, isSubscription, subscriptionId);
      const delayedOrdersResponse = await getAllDelayedOrders();
      const { data } = response;
      const responseDrivers = await getAllActiveDrivers();
      const responseLaundries = await getAllActiveLaundries();
      const responseStatusList = await getAllStatus();
      const responseSlotsList = await getAllSlots();
      const responseServicesList = await getAllServices();
      if (data.result.isSuccess) {
        setDrivers(responseDrivers.data.data);
        setLaundries(responseLaundries.data.data);
        setStatusList(responseStatusList.data.data);
        setServicesList(responseServicesList.data.data);
        setSlots(responseSlotsList.data.data);
        setPendingOrdersCount(responsePendingOrdersCount.data.data.count);

        // Store delayed orders data
        if (delayedOrdersResponse.data.result.isSuccess) {
          setDelayedOrders(delayedOrdersResponse.data.data);
        } else {
          setDelayedOrders([]);
        }

        //getRegularOrderColumns();
        setData(data.data.map((prop) => makeTableRow(prop, responseServicesList.data.data)));
        //setError("");
      } else {
        showErrorNotification(data.result.description);
        if (data.result.code == -2) {
          redirectToLogout();
        }
      }
    } catch (ex) {
      showErrorNotification("Failed to fetch orders " + ex);
      setDelayedOrders([]);
    }
    setIsLoading(false);
  };

  const bulkAssignDriverAction = async () => {
    setExecuteAssignDriver(false);
    setIsLoading(true);
    try {
      const response = await bulkAssignDriver(ids, assignedDriverId, assignDriverType);
      const { data } = response;
      if (data.result.isSuccess) {
        showSuccessNotification("Driver Assigned Successfully");
        setAssignDriverModal(false);
        setForceRefresh(true);
      } else {
        showErrorNotification(data.result.description);
        setIsLoading(false);
      }
    } catch (ex) {
      showErrorNotification("Failed to assign driver");
      setIsLoading(false);
    }
  };


  const bulkAssignLaundryAction = async () => {
    setExecuteAssignLaundry(false);
    setIsLoading(true);
    try {
      const response = await bulkAssignLaundries(ids, assignedLaundryId);
      const { data } = response;
      if (data.result.isSuccess) {
        showSuccessNotification("Laundry Assigned Successfully");
        setAssignLaundryModal(false);
        setForceRefresh(true);
      } else {
        showErrorNotification(data.result.description);
        setIsLoading(false);
      }
    } catch (ex) {
      showErrorNotification("Failed to assign laundry");
      setIsLoading(false);
    }
  };

  const bulkUpdateStatusAction = async () => {
    setExecuteStatusUpdate(false);
    setIsLoading(true);
    try {
      const response = await bulkUpdateOrderStatus(ids, newStatus, refundToWallet);
      const { data } = response;
      if (data.result.isSuccess) {
        showSuccessNotification("Status Updated Successfully");
        setUpdateStatusModal(false);
        setForceRefresh(true);
      } else {
        showErrorNotification(data.result.description);
        setIsLoading(false);
      }
    } catch (ex) {
      showErrorNotification("Failed to update status");
      setIsLoading(false);
    }
  };


  const bulkUpdateSlotsAction = async () => {
    // setExecuteSlotsUpdate(false);
    setIsLoading(true);
    try {
      const response = await bulkUpdateOrderSlots(ids, pickupDate,
        pickupTimeslot,
        dropoffDate,
        dropoffTimeslot);
      const { data } = response;
      if (data.result.isSuccess) {
        showSuccessNotification("Slots Updated Successfully");
        setUpdateSlotsModal(false);
        setForceRefresh(true);
      } else {
        showErrorNotification(data.result.description);
        setIsLoading(false);
      }
    } catch (ex) {
      showErrorNotification("Failed to update slots");
      setIsLoading(false);
    }
  };

  useAsyncEffect(async () => {
    if (props.location.pathname.includes("subscription")) {
      setIsSubscription(1);
      if (props.match.params.id != null) {
        setSubscriptionId(props.match.params.id);
      }
    }
    if (executeAssignDriver) {
      bulkAssignDriverAction();
    } else if (executeAssignLaundry) {
      bulkAssignLaundryAction();
    } else {
      if (endDate == null) {
        var endDateStored = localStorage.getItem("searchEndDate");
        if (endDateStored != null && endDateStored.toUpperCase() !== "NULL") {
          setEndDate(new Date(endDateStored));
        }
        else {
          setEndDate(new Date());
        }
      }
      if (startDate == null) {
        var startDateStored = localStorage.getItem("searchStartDate");
        if (startDateStored != null && startDateStored.toUpperCase() !== "NULL") {
          setStartDate(new Date(startDateStored));
        }
        else {
          setStartDate(new Date().setDate(new Date().getDate() - 7));
        }
      }
      // if (filterBy == null) {
      var searchFilterBy = localStorage.getItem("searchFilterBy");
      if (searchFilterBy != null && searchFilterBy.toUpperCase() !== "NULL") {
        setFilterBy(searchFilterBy);
      }
      //   else{
      //     setFilterBy(0);
      //   }
      // }
      // if (activeOnly == null) {
      var searchActiveOnly = localStorage.getItem("searchActiveOnly");
      if (searchActiveOnly != null && searchActiveOnly.toUpperCase() !== "NULL") {
        setActiveOnly(searchActiveOnly);
      }
      //   else{
      //     setActiveOnly(1);
      //   }
      // }
      if (startDate != null && endDate != null && filterBy != null && activeOnly != null) {
        fetchOrders();
      }
    }
  }, [
    forceRefresh,
    executeAssignLaundry,
    executeAssignDriver,
    executeStatusUpdate,
    executeSlotsUpdate,
    startDate,
    endDate,
    filterBy,
    activeOnly
  ]);

  const makeTableRow = (info, servicesList) => {
    info = parseWashingFeatures(info);

    //Reset List
    for (var j = 0; j < servicesList.length; j++) {
      info[servicesList[j].nameEn + "Q"] = 0;
    }
    info.totalBags = 0;
    info.totalPerItem = 0;
    for (var i = 0; i < info.orderServices.length; i++) {
      if (info.orderServices[i].isPerItem === 1) {
        info.totalPerItem = info.totalPerItem + info.orderServices[i].quantity;
      }
      else {
        info.totalBags = info.totalBags + info.orderServices[i].quantity;
        for (var j = 0; j < servicesList.length; j++) {
          if (servicesList[j].id === info.orderServices[i].serviceId) {
            info[servicesList[j].nameEn + "Q"] = info.orderServices[i].quantity;
            break;
          }
        }
      }
    }

    // info.placedOnText = dateFormat(
    //   new Date(info.placedOn),
    //   "d-mmm-yyyy hh:MM:ss TT"
    // );
    // if(info.placedOnText != null && info.placedOnText != ""){
    //   info.placedOnSplittedText = dateFormat(
    //     new Date(info.placedOn),
    //     "d-mmm-yyyy hh:MM:ssTT"
    //   ).split(" ");

    // }
    // if(info.pickupDate != null){
    //   info.pickupDateText = dateFormat(new Date(info.pickupDate), "d-mmm-yyyy");
    //   if(info.pickupDateTime != null){
    //     info.pickupDateTimeText = dateFormat(new Date(info.pickupDateTime), "d-mmm-yyyy hh:MM TT");
    //   }
    //   else{
    //     info.pickupDateTimeText = "";
    //   }
    // }

    // info.dropoffDateText = dateFormat(new Date(info.dropoffDate), "d-mmm-yyyy");
    // if(info.dropoffDateTime != null){
    //   info.dropoffDateTimeText = dateFormat(new Date(info.dropoffDateTime),"d-mmm-yyyy hh:MM TT");
    // }
    // else{
    //   info.dropoffDateTimeText = "";
    // }
    // if (info.needMoreBags == 1) {
    //   info.needMoreBagsText = "Yes";
    // } else {
    //   info.needMoreBagsText = "No";
    // }
    // if (info.deliverEarlier == 1) {
    //   info.deliverEarlierText = "Yes";
    // } else {
    //   info.deliverEarlierText = "No";
    // }

    // if (info.services.length > 2) {
    //   info.services = info.services.slice(0, -2).replaceAll("doobi ", "");
    // }
    // if(info.transactionDetailsById.length > 0){
    //   if(info.transactionDetailsById[0].fee != null){
    //     info.feeRounded = info.transactionDetailsById[0].fee.toFixed(3);
    //   }
    //   if(info.transactionDetailsById[0].feeVat != null){
    //     info.feeVatRounded = info.transactionDetailsById[0].feeVat.toFixed(3);
    //   }
    //   if(info.transactionDetailsById[0].feeWithVat != null){
    //     info.feeWithVatRounded = info.transactionDetailsById[0].feeWithVat.toFixed(3);
    //   }
    //   // if(info.transactionDetailsById[0].feeWithVat != null){
    //   //   info.net = (info.finalPrice - (info.transactionDetailsById[0].feeWithVat)).toFixed(3);
    //   // }
    // }
    // else{
    //   info.feeRounded = 0.0.toFixed(3);
    //   info.feeVatRounded = 0.0.toFixed(3);
    //   info.feeWithVatRounded = 0.0.toFixed(3);
    //   // info.net = info.finalPrice.toFixed(3);
    // }
    // info.isPickedFromLaundry = getIsPickedFromLaundry(info) ? "Yes" : "No";

    // info.paymentMethodName = info.paymentMethodByPaymentMethodId.name;
    // if(info.walletBalanceUsed > 0 && info.paymentMethodByPaymentMethodId.id != 4){
    //   info.paymentMethodName = info.paymentMethodName +" + Wallet";
    // }

    // info.washingTimestamp = "";
    // for (var i = 0; i < info.orderStatusHistoriesById.length; i++) {
    //       if(info.orderStatusHistoriesById[i].statusTextByStatus.textEn.toUpperCase() === "WASHING"){
    //         info.washingTimestamp = dateFormat(new Date(info.orderStatusHistoriesById[i].onDatetime), "d-mmm-yyyy hh:MM TT") ;
    //         break;
    //       }
    // }

    return {
      ...info,
      isRequireDropOffChange: (
        info.requireDropoffChange != null && info.requireDropoffChange === 1 ? "Yes" : 'No'
      ),
      isNegativeWalletBalanceFlag: (
        info.negativeWalletBalanceFlag != null && info.negativeWalletBalanceFlag === 1 ? "Yes" : "No"
      ),
      // idForm: (
      //   info.publicId
      // ),
      // userIdForm: (
      //   "C"+zeroFill(info.userId,5)
      // ),
      // subscriptionIdForm: (
      //   info.subscriptionId != null ? "S"+zeroFill(info.subscriptionId,5) : ''
      // ),
      // dayOfWeek: days[ new Date(info.placedOn).getDay() ],
      // pickUpDayOfWeek: info.pickupDate != null ? days[ new Date(info.pickupDate).getDay() ] : '',
      // dropOffDayOfWeek: days[ new Date(info.dropoffDate).getDay() ],
      // username: info.userByUserId.firstName + " " + info.userByUserId.lastName,
      // amount: info.finalPrice.toFixed(3),
      // priceWithoutDiscountAndVat: (info.price + info.discountAmount + info.proDiscount).toFixed(3),
      // discountedAmount: (info.finalPrice - info.vat).toFixed(3),
      // net: ((info.finalPrice - info.vat) - info.feeWithVatRounded).toFixed(3),
      // proDiscountAmount: (info.proDiscount).toFixed(3),
      // vatFormatted: info.vat.toFixed(3),
      // walletBalanceUsedFormatted: info.walletBalanceUsed.toFixed(3),
      // minimumAmountFeeFormatted: info.minimumAmountFee.toFixed(3),
      // pickupTimeOnlySlot: info.availabilitySlotByPickupTimeslot != null ?(
      // info.availabilitySlotByPickupTimeslot.startTime +
      //   " - " +
      //   info.availabilitySlotByPickupTimeslot.endTime) : '',
      // pickupTimeslot: info.availabilitySlotByPickupTimeslot != null ? (
      //   info.pickupDateText +
      //   " " +
      //   info.availabilitySlotByPickupTimeslot.startTime +
      //   " - " +
      //   info.availabilitySlotByPickupTimeslot.endTime) : '',
      // dropoffTimeOnlySlot:
      // info.availabilitySlotByDropoffTimeslot.startTime +
      // " - " +
      // info.availabilitySlotByDropoffTimeslot.endTime,
      // dropoffTimeslot:
      //   info.dropoffDateText +
      //   " " +
      //   info.availabilitySlotByDropoffTimeslot.startTime +
      //   " - " +
      //   info.availabilitySlotByDropoffTimeslot.endTime,
      actions: (
        <div className="actions-right">
          <Tooltip title="View Details">
            <Button
              size="small"
              color="primary"
              variant="contained"
              onClick={() => {
                accessOrderPage(info.id);
              }}
            >
              <Box component={Receipt} />
            </Button>
          </Tooltip>
        </div>
      ),
    };
  };

  const getRegularOrderColumns = () => {
    columns = [
      {
        dataField: "idForm",
        text: "ID",
        sort: true,
      },
      {
        dataField: "status",
        text: "Status",
        sort: true,
      },
      {
        dataField: "username",
        text: "User Name",
        sort: true,
      },
      {
        dataField: "userIdForm",
        text: "User ID",
        sort: true,
      },
      {
        dataField: "isNegativeWalletBalanceFlag",
        text: "Negative User Wallet",
        sort: true,
        csvExport: false,
      },
      // {
      //   dataField: "subscriptionIdForm",
      //   text: "Subscription ID",
      //   sort: true,
      // },
      {
        dataField: "userMobileNumber",
        text: "Mobile Number",
        sort: true,
      },
      {
        dataField: "placedOnForm",
        text: "Placed On",
        sort: true,
        csvExport: false,
        sortFunc: dateSortFunc,
      },
      {
        dataField: "placedOnDayOfWeek",
        text: "Placed On Day of Week",
        sort: true,
        csvExport: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "placedOnDateForm",
        text: "Placed On Date",
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "placedOnTimeForm",
        text: "Placed On Time",
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "pickupCity",
        text: "Pickup City",
        sort: true,
      },
      {
        dataField: "pickupTimeslotFullForm",
        text: "Pickup DateTime",
        sort: true,
        csvExport: false,
        sortFunc: slotDateSortFunc,
      },
      {
        dataField: "pickupDateDayOfWeekForm",
        text: "Pick Up Day of Week",
        sort: true,
        csvExport: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "pickupDateForm",
        text: "Pickup Date",
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "pickupTimeOnly",
        text: "Pickup TimeSlot",
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "dropoffCity",
        text: "Dropoff City",
        sort: true,
      },
      {
        dataField: "dropoffTimeslotFullForm",
        text: "Dropoff DateTime",
        sort: true,
        csvExport: false,
        sortFunc: slotDateSortFunc,
      },
      {
        dataField: "isRequireDropOffChange",
        text: "Require Dropoff Slot Change",
        sort: true,
        csvExport: false,
      },

      {
        dataField: "deliverEarlierForm",
        text: "Deliver Earlier",
        sort: true,
      },
      {
        dataField: "dropoffDateDayOfWeekForm",
        text: "Drop Off Day of Week",
        sort: true,
        csvExport: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "dropoffDateForm",
        text: "Dropff Date",
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "dropoffTimeOnly",
        text: "Dropoff TimeSlot",
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "userNotes",
        text: "User Notes",
        sort: true,
      },
      {
        dataField: "orderNotes",
        text: "Order Notes",
        sort: true,
      },
      {
        dataField: "priceWithoutDiscountAndVat",
        text: "Price",
        sort: true,
        sortFunc: numericSortFunc,
      },
      {
        dataField: "proDiscountForm",
        text: "Pro Discount",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "minimumAmountFeeForm",
        text: "Minimum Order Adjustment",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "vatForm",
        text: "VAT Order",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "finalPriceForm",
        text: "Price with VAT",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "discountAmountForm",
        text: "Discount",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "discountedAmount",
        text: "Discounted Price",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "walletBalanceUsedForm",
        text: "Wallet Balance Used",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "feeRounded",
        text: "PG Fees",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "feeVatRounded",
        text: "PG Fees VAT",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "feeWithVatRounded",
        text: "PG Fees With VAT",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "net",
        text: "Net",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "couponCode",
        text: "Coupon Code",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "paymentMethodName",
        text: "Payment Method",
        sort: true,
      }];
    if (servicesList.length > 0) {
      servicesList.sort(function (a, b) {
        var x = a.nameEn.toLowerCase();
        var y = b.nameEn.toLowerCase();
        return x < y ? -1 : x > y ? 1 : 0;
      });
    }
    for (var j = 0; j < servicesList.length; j++) {
      if (servicesList[j].isPerItem === 0) {
        columns.push({
          dataField: servicesList[j].nameEn + "Q",
          text: servicesList[j].nameEn.replaceAll("doobi ", ""),
          sort: true,
          sortFunc: numericSortFunc
        });
      }
    }
    columns.push({
      dataField: "totalPerItem",
      text: "Per Item Count",
      sort: true,
      sortFunc: numericSortFunc
    },
      {
        dataField: "totalBags",
        text: "Total Bags",
        sort: true,
        sortFunc: numericSortFunc
      },
      {
        dataField: "needMoreBagsForm",
        text: "Need More Bags",
        sort: true,
      },
      {
        dataField: "isPickedFromLaundry",
        text: "Picked from Laundry",
        sort: true,
      },
      {
        dataField: "assignedDriverPickupName",
        text: "Pickup Driver",
        sort: true,
      },
      {
        dataField: "assignedDriverDropoffName",
        text: "Dropoff Driver",
        sort: true,
      },
      {
        dataField: "assignedLaundryName",
        text: "Laundry",
        sort: true,
      },
      {
        dataField: "scent",
        text: "Scent",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "starch",
        text: "Starch",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "thobeBackCrease",
        text: "Thobe Back Crease",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "ghetra",
        text: "Ghetra Crease",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "shirtsSleeveCrease",
        text: "Shirts Sleeve Crease",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "pantsTravelersCrease",
        text: "Pants Travelers Crease",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },

      {
        dataField: "pickupDateTimeForm",
        text: "Datetime Picked Up",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "dropoffDateTimeForm",
        text: "Datetime Dropped Up",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "pickupFlat",
        text: "Pickup Flat",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "pickupHouse",
        text: "Pickup Building",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "pickupRoad",
        text: "Pickup Road",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "pickupBlock",
        text: "Pickup Block",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "pickupLocationCoordinates",
        text: "Pickup Coordinates",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "pickupAddressType",
        text: "Pickup Address Type",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "pickupAddressInstructions",
        text: "Pickup Address Instructions",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "pickupInstructions",
        text: "Pickup Instruction",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },

      {
        dataField: "dropoffFlat",
        text: "Dropoff Flat",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "dropoffHouse",
        text: "Dropoff Building",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "dropoffRoad",
        text: "Dropoff Road",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "dropoffBlock",
        text: "Dropoff Block",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "dropoffLocationCoordinates",
        text: "Dropoff Coordinates",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "dropoffAddressType",
        text: "Dropoff Address Type",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "dropoffAddressInstructions",
        text: "Dropoff Address Instructions",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "dropoffInstructions",
        text: "Dropoff Instruction",
        sort: true,
        headerStyle: { display: "none" },
        style: { display: "none" }
      },
      {
        dataField: "washingTimestampForm",
        text: "Washing Timestamp",
        sort: true,
        csvExport: true,
        sortFunc: slotDateSortFunc,
      },
      {
        dataField: "actions",
        text: "Actions",
        csvExport: false,
      },
    );
  }

  return (
    <>
      {alert}
      {getRegularOrderColumns()}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>
              <CardHeader
                subheader={
                  <>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Box component="span">{isSubscription != null && isSubscription === 1 ? 'Subscription ' : ''}{subscriptionId != null ? "S" + zeroFill(subscriptionId, 5) + " " : ''}Orders</Box>
                    </Box>
                  </>
                }
                classes={{ root: classes.cardHeaderRoot }}
              ></CardHeader>

              <ToolkitProvider
                data={data}
                keyField="id"
                columns={isSubscription === 1 ? [
                  {
                    dataField: "idForm",
                    text: "ID",
                    sort: true,
                  },
                  {
                    dataField: "username",
                    text: "User Name",
                    sort: true,
                  },
                  {
                    dataField: "userIdForm",
                    text: "User ID",
                    sort: true,
                  },
                  {
                    dataField: "subscriptionIdForm",
                    text: "Subscription ID",
                    sort: true,
                  },
                  {
                    dataField: "userByUserId.mobileNumber",
                    text: "Mobile Number",
                    sort: true,
                  },
                  {
                    dataField: "placedOnText",
                    text: "Placed On",
                    sort: true,
                    csvExport: false,
                    sortFunc: dateSortFunc,
                  },
                  {
                    dataField: "dayOfWeek",
                    text: "Placed On Day of Week",
                    sort: true,
                    csvExport: true,
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  {
                    dataField: "placedOnSplittedText[0]",
                    text: "Placed On Date",
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  {
                    dataField: "placedOnSplittedText[1]",
                    text: "Placed On Time",
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  {
                    dataField: "cityByPickupCityId.cityEn",
                    text: "Pickup City",
                    sort: true,
                  },
                  {
                    dataField: "pickupTimeslot",
                    text: "Pickup DateTime",
                    sort: true,
                    csvExport: false,
                    sortFunc: slotDateSortFunc,
                  },
                  {
                    dataField: "pickUpDayOfWeek",
                    text: "Pick Up Day of Week",
                    sort: true,
                    csvExport: true,
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  {
                    dataField: "pickupDateText",
                    text: "Pickup Date",
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  {
                    dataField: "pickupTimeOnlySlot",
                    text: "Pickup TimeSlot",
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  {
                    dataField: "cityByDropoffCityId.cityEn",
                    text: "Dropoff City",
                    sort: true,
                  },
                  {
                    dataField: "dropoffTimeslot",
                    text: "Dropoff DateTime",
                    sort: true,
                    csvExport: false,
                    sortFunc: slotDateSortFunc,
                  },
                  {
                    dataField: "dropOffDayOfWeek",
                    text: "Drop Off Day of Week",
                    sort: true,
                    csvExport: true,
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  {
                    dataField: "dropoffDateText",
                    text: "Dropff Date",
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  {
                    dataField: "dropoffTimeOnlySlot",
                    text: "Dropoff TimeSlot",
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  {
                    dataField: "statusTextByStatus.textEn",
                    text: "Status",
                    sort: true,
                  },
                  {
                    dataField: "isPickedFromLaundry",
                    text: "Picked from Laundry",
                    sort: true,
                  },
                  {
                    dataField: "driverByAssignedDriver.fullNameEn",
                    text: "Pickup Driver",
                    sort: true,
                  },
                  {
                    dataField: "driverByAssignedDriverDropoff.fullNameEn",
                    text: "Dropoff Driver",
                    sort: true,
                  },
                  {
                    dataField: "laundryByAssignedLaundry.name",
                    text: "Laundry",
                    sort: true,
                  },
                  {
                    dataField: "scent",
                    text: "Scent",
                    sort: true,
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  {
                    dataField: "starch",
                    text: "Starch",
                    sort: true,
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  // {
                  //   dataField: "thobeBackCrease",
                  //   text: "Thobe Back Crease",
                  //   sort: true,
                  //   headerStyle: {display : "none"},
                  //   style : {display : "none"}
                  // },
                  {
                    dataField: "ghetra",
                    text: "Ghetra Type + Starch",
                    sort: true,
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  // {
                  //   dataField: "shirtsSleeveCrease",
                  //   text: "Shirts Sleeve Crease",
                  //   sort: true,
                  //   headerStyle: {display : "none"},
                  //   style : {display : "none"}
                  // },
                  // {
                  //   dataField: "pantsTravelersCrease",
                  //   text: "Pants Travelers Crease",
                  //   sort: true,
                  //   headerStyle: {display : "none"},
                  //   style : {display : "none"}
                  // },
                  {
                    dataField: "pickupDateTimeText",
                    text: "Datetime Picked Up",
                    sort: true,
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  {
                    dataField: "dropoffDateTimeText",
                    text: "Datetime Dropped Up",
                    sort: true,
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  {
                    dataField: "pickupFlat",
                    text: "Pickup Flat",
                    sort: true,
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  {
                    dataField: "pickupHouse",
                    text: "Pickup Building",
                    sort: true,
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  {
                    dataField: "pickupRoad",
                    text: "Pickup Road",
                    sort: true,
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  {
                    dataField: "pickupBlock",
                    text: "Pickup Block",
                    sort: true,
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  {
                    dataField: "pickupLocationCoordinates",
                    text: "Pickup Coordinates",
                    sort: true,
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  {
                    dataField: "pickupAddressType",
                    text: "Pickup Address Type",
                    sort: true,
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  {
                    dataField: "pickupAddressInstructions",
                    text: "Pickup Address Instructions",
                    sort: true,
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  {
                    dataField: "pickupInstructions",
                    text: "Pickup Instruction",
                    sort: true,
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },

                  {
                    dataField: "dropoffFlat",
                    text: "Dropoff Flat",
                    sort: true,
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  {
                    dataField: "dropoffHouse",
                    text: "Dropoff Building",
                    sort: true,
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  {
                    dataField: "dropoffRoad",
                    text: "Dropoff Road",
                    sort: true,
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  {
                    dataField: "dropoffBlock",
                    text: "Dropoff Block",
                    sort: true,
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  {
                    dataField: "dropoffLocationCoordinates",
                    text: "Dropoff Coordinates",
                    sort: true,
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  {
                    dataField: "dropoffAddressType",
                    text: "Dropoff Address Type",
                    sort: true,
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  {
                    dataField: "dropoffAddressInstructions",
                    text: "Dropoff Address Instructions",
                    sort: true,
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  {
                    dataField: "dropoffInstructions",
                    text: "Dropoff Instruction",
                    sort: true,
                    headerStyle: { display: "none" },
                    style: { display: "none" }
                  },
                  {
                    dataField: "actions",
                    text: "Actions",
                    csvExport: false,
                  },
                ] : columns}
                search
                exportCSV
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    <Grid container className="pl-4">
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        style={{ marginBottom: "15px" }}
                      >

                        <Tooltip
                          title={pendingOrdersCount + " Order Updates Pending"}
                          style={{ margin: "5px" }}
                        >
                          <Button
                            variant="contained"
                            size="small"
                            classes={{
                              root: classes.buttonContainedError,
                            }}
                            onClick={() => {
                              accessBagUpdatesPage();
                            }}
                          >
                            <span>{pendingOrdersCount} Orders Pending Action</span>
                          </Button>
                        </Tooltip>
                        <Tooltip
                          title={"Bags Weight Report"}
                          style={{ margin: "5px" }}
                        >
                          <Button
                            variant="contained"
                            size="small"
                            classes={{
                              root: classes.buttonContainedInfo,
                            }}
                            onClick={() => {
                              accessBagWeightReportPage();
                            }}
                          >
                            <span>Bags Weight Report</span>
                          </Button>
                        </Tooltip>

                        <Tooltip
                          title="Bulk Update Order Status"
                          style={{ margin: "5px" }}
                        >
                          <Button
                            variant="contained"
                            size="small"
                            classes={{
                              root: classes.buttonContainedSuccess,
                            }}
                            onClick={() => {
                              if (ids.length > 0) {
                                clearCurrentRecord();
                                setUpdateStatusModal(true);
                              }
                            }}
                          >
                            <span>Update Status</span>
                          </Button>
                        </Tooltip>
                        <Tooltip
                          title="Bulk Assign Pickup Driver"
                          style={{ margin: "5px" }}
                        >
                          <Button
                            variant="contained"
                            size="small"
                            classes={{
                              root: classes.buttonContainedWarning,
                            }}
                            onClick={() => {
                              if (ids.length > 0) {
                                clearCurrentRecord();
                                setAssignDriverType(1);
                                setAssignDriverModal(true);
                              }
                            }}
                          >
                            <span>Assign Pickup Driver</span>
                          </Button>
                        </Tooltip>
                        <Tooltip
                          title="Bulk Assign Dropoff Driver"
                          style={{ margin: "5px" }}
                        >
                          <Button
                            variant="contained"
                            size="small"
                            classes={{
                              root: classes.buttonContainedInfo,
                            }}
                            onClick={() => {
                              if (ids.length > 0) {
                                clearCurrentRecord();
                                setAssignDriverType(0);
                                setAssignDriverModal(true);
                              }
                            }}
                          >
                            <span>Assign Dropoff Driver</span>
                          </Button>
                        </Tooltip>

                        <Tooltip
                          title="Bulk Assign Laundry"
                          style={{ margin: "5px" }}
                        >
                          <Button
                            variant="contained"
                            size="small"
                            classes={{
                              root: classes.buttonContainedError,
                            }}
                            onClick={() => {
                              if (ids.length > 0) {
                                clearCurrentRecord();
                                setAssignLaundryModal(true);
                              }
                            }}
                          >
                            <span>Assign Laundry</span>
                          </Button>
                        </Tooltip>

                        <Tooltip
                          title="Bulk Update Pickup Slots"
                          style={{ margin: "5px" }}
                        >
                          <Button
                            variant="contained"
                            size="small"
                            classes={{
                              root: classes.buttonContainedWarning,
                            }}
                            onClick={() => {
                              if (ids.length > 0) {
                                clearCurrentRecord();
                                setUpdateSlotsType(0);
                                setUpdateSlotsModal(true);
                              }
                            }}
                          >
                            <span>Update Pickup Timeslots</span>
                          </Button>
                        </Tooltip>

                        <Tooltip
                          title="Bulk Update Dropoff Slots"
                          style={{ margin: "5px" }}
                        >
                          <Button
                            variant="contained"
                            size="small"
                            classes={{
                              root: classes.buttonContainedSuccess,
                            }}
                            onClick={() => {
                              if (ids.length > 0) {
                                clearCurrentRecord();
                                setUpdateSlotsType(1);
                                setUpdateSlotsModal(true);
                              }
                            }}
                          >
                            <span>Update Dropoff Timeslots</span>
                          </Button>
                        </Tooltip>
                        {/* <Tooltip
                          title="This will copy to your download the table content."
                          style={{ margin: "5px" }}
                        > */}
                        <ExportCSVButton
                          className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedSizeSmall MuiButton-sizeSmall"
                          {...props.csvProps}
                        >
                          <span className="MuiButton-label">Download</span>
                        </ExportCSVButton>
                        {/* </Tooltip> */}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <div
                          id="datatable-basic_filter"
                          className="dataTables_filter px-4 pb-1 float-right"
                        >
                          <label>
                            Search:
                            <SearchBar
                              className="form-control-sm"
                              placeholder=""
                              {...props.searchProps}
                            />
                          </label>
                        </div>
                      </Grid>
                    </Grid>

                    <Grid container className="pl-4">
                      <Grid item xs={12} sm={12}>
                        <form>
                          View by &emsp;
                          <div
                            style={{
                              display: "inline-block",
                              marginBottom: "20px",
                            }}
                          >
                            <Select
                              variant="outlined"
                              value={filterBy}
                              onChange={(e) => {
                                localStorage.setItem("searchFilterBy", e.target.value);
                                setFilterBy(e.target.value);
                              }}
                              IconComponent={KeyboardArrowDown}
                            >
                              <MenuItem value={0}>Placed On</MenuItem>
                              <MenuItem value={1}>Pickup Date</MenuItem>
                              <MenuItem value={2}>Dropoff Date</MenuItem>
                            </Select>
                          </div>{" "}
                          &emsp; From &emsp;
                          <div style={{ display: "inline-block" }}>
                            <DatePicker
                              timeCaption="Start Date"
                              selected={startDate}
                              customInput={<OutlinedInput />}
                              onChange={(date) => {
                                localStorage.setItem("searchStartDate", date);
                                setStartDate(date);
                              }}
                              dateFormat="dd-MM-yyyy"
                            />
                          </div>{" "}
                          &emsp; to &emsp;
                          <div style={{ display: "inline-block" }}>
                            <DatePicker
                              timeCaption="End Date"
                              selected={endDate}
                              customInput={<OutlinedInput />}
                              onChange={(date) => {
                                localStorage.setItem("searchEndDate", date);
                                setEndDate(date);
                              }}
                              dateFormat="dd-MM-yyyy"
                            />
                          </div>
                          &emsp;
                          <div
                            style={{
                              display: "inline-block",
                              marginBottom: "20px",
                            }}
                          >
                            <Select
                              variant="outlined"
                              value={activeOnly}
                              onChange={(e) => {
                                localStorage.setItem("searchActiveOnly", e.target.value);
                                setActiveOnly(e.target.value);
                              }}
                              IconComponent={KeyboardArrowDown}
                            >
                              <MenuItem value={1}>Successful only</MenuItem>
                              <MenuItem value={0}>All Orders</MenuItem>
                              <MenuItem value={-1}>Live Orders</MenuItem>
                            </Select>
                          </div>{" "}
                        </form>
                      </Grid>
                    </Grid>
                    <Grid container className="pl-4">
                      <Grid item xs={12} sm={12}>
                        <div
                          style={{
                            marginBottom: "20px",
                          }}
                        >
                          {selectedCount} Orders Selected
                        </div>
                      </Grid>
                    </Grid>
                    <BootstrapTable
                      ref={componentRef}
                      {...props.baseProps}
                      bootstrap4={true}
                      pagination={pagination}
                      bordered={true}
                      striped={true}
                      selectRow={selectRow}
                      rowStyle={rowStyle}
                      noDataIndication={() =>
                        isLoading ? (
                          <Box
                            component={Grid}
                            container
                            justifyContent="center"
                            className="justify-content-center"
                          >
                            <div
                              className="text-center"
                              style={{ width: "20%" }}
                            >
                              <LoadingAnimation />{" "}
                            </div>
                          </Box>
                        ) : (
                          <h4>No Records</h4>
                        )
                      }
                      id="main-table"
                    />
                  </div>
                )}
              </ToolkitProvider>
            </Card>
          </Grid>
        </Grid>


        <Dialog
          classes={{
            root: classes.center + " " + classes.modalRoot,
            paper: classes.modal + " " + classes.modalSmall,
          }}
          open={assignLaundryModal && !isLoading}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setAssignLaundryModal(false)}
        >
          <DialogTitle disableTypography className={classes.modalHeader}>
            <h4 className={classes.modalTitle}>Assign Laundry</h4>
          </DialogTitle>
          <DialogContent
            className={classes.modalBody + " " + classes.modalSmallBody}
          >
            <form>
              <FormGroup>
                <FormLabel>Laundry</FormLabel>
                <FormControl variant="outlined" fullWidth>
                  <Select
                    value={assignedLaundryId}
                    onChange={(e) => setAssignedLaundryId(e.target.value)}
                    IconComponent={KeyboardArrowDown}
                  >
                    {laundries.map(function (laundry, i) {
                      return (
                        <MenuItem value={laundry.id}>
                          {laundry.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </FormGroup>
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setAssignLaundryModal(false)}>Cancel</Button>
            <Button
              onClick={() => bulkAssignLaundryAction()}
              classes={{
                root: classes.buttonContainedPurple100,
              }}
              variant="contained"
            >
              Assign
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          classes={{
            root: classes.center + " " + classes.modalRoot,
            paper: classes.modal + " " + classes.modalSmall,
          }}
          open={assignDriverModal && !isLoading}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setAssignDriverModal(false)}
        >
          <DialogTitle disableTypography className={classes.modalHeader}>
            <h4 className={classes.modalTitle}>Assign {assignDriverType == 1 ? 'Pickup' : 'Dropoff'} Driver</h4>
          </DialogTitle>
          <DialogContent
            className={classes.modalBody + " " + classes.modalSmallBody}
          >
            <form>
              <FormGroup>
                <FormLabel>Driver</FormLabel>
                <FormControl variant="outlined" fullWidth>
                  <Select
                    value={assignedDriverId}
                    onChange={(e) => setAssignedDriverId(e.target.value)}
                    IconComponent={KeyboardArrowDown}
                  >
                    {drivers.map(function (driver, i) {
                      return (
                        <MenuItem value={driver.id}>
                          {driver.fullNameEn}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </FormGroup>
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setAssignDriverModal(false)}>Cancel</Button>
            <Button
              onClick={() => bulkAssignDriverAction()}
              classes={{
                root: classes.buttonContainedPurple100,
              }}
              variant="contained"
            >
              Assign
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          classes={{
            root: classes.center + " " + classes.modalRoot,
            paper: classes.modal + " " + classes.modalSmall,
          }}
          open={updateStatusModal && !isLoading}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setUpdateStatusModal(false)}
        >
          <DialogTitle disableTypography className={classes.modalHeader}>
            <h4 className={classes.modalTitle}>Update Status</h4>
          </DialogTitle>
          <DialogContent
            className={classes.modalBody + " " + classes.modalSmallBody}
          >
            <form>
              <FormGroup>
                <FormLabel>New Status</FormLabel>
                <FormControl variant="outlined" fullWidth>
                  <Select
                    value={newStatus}
                    onChange={(e) => setNewStatus(e.target.value)}
                    IconComponent={KeyboardArrowDown}
                  >
                    {statusList.map(function (sts, i) {
                      return <MenuItem value={sts.id}>{sts.textEn}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </FormGroup>
              {newStatus === -2 ? (<FormGroup>
                <FormLabel>Refund to Wallet</FormLabel>
                <FormControl variant="outlined" fullWidth>
                  <Select
                    value={refundToWallet}
                    onChange={(e) => setRefundToWallet(e.target.value)}
                    IconComponent={KeyboardArrowDown}
                  >
                    <MenuItem value={1}>Yes</MenuItem>
                    <MenuItem value={0}>No</MenuItem>
                  </Select>
                </FormControl>
              </FormGroup>) : ''}
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setUpdateStatusModal(false)}>Cancel</Button>
            <Button
              onClick={() => bulkUpdateStatusAction()}
              classes={{
                root: classes.buttonContainedPurple100,
              }}
              variant="contained"
            >
              Update
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          classes={{
            root: classes.center + " " + classes.modalRoot,
            paper: classes.modal + " " + classes.modalSmall,
          }}
          open={updateSlotsModal && !isLoading}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setUpdateSlotsModal(false)}
        >
          <DialogTitle disableTypography className={classes.modalHeader}>
            <h4 className={classes.modalTitle}>Update Slots</h4>
          </DialogTitle>
          <DialogContent
            className={classes.modalBody + " " + classes.modalSmallBody}
          >
            <form>
              <Grid container justify="space-between">
                {updateSlotsType === 0 ? (<Grid item xs={12} sm={12} md={12}>
                  <FormGroup>
                    <FormLabel>New Pickup Date</FormLabel>
                    <DatePicker
                      selected={pickupDate}
                      fullWidth
                      customInput={<OutlinedInput fullWidth />}
                      onChange={(date) => setPickupDate(date)}
                      dateFormat="MMMM d, yyyy"
                    />
                  </FormGroup>

                  <FormGroup>
                    <FormLabel>New Pickup Timeslot</FormLabel>
                    <FormControl variant="outlined" fullWidth>
                      <Select
                        value={pickupTimeslot}
                        onChange={(e) => setPickupTimeslot(e.target.value)}
                        IconComponent={KeyboardArrowDown}
                      >
                        {slots
                          .sort((a, b) => (a.startTime > b.startTime ? 1 : -1))
                          .map(function (slot, i) {
                            if (
                              pickupDate != null &&
                              slot.dayId == pickupDate.getDay() + 1 &&
                              (slot.deliveryType == 0 || slot.deliveryType == 2) && slot.isSubscription == 0
                            ) {
                              return (
                                <MenuItem value={slot.id}>
                                  {slot.startTime} - {slot.endTime} ({slot.driverByDriverId != null ? slot.driverByDriverId.fullNameEn : ''})
                                </MenuItem>
                              );
                            }
                          })}
                      </Select>
                    </FormControl>
                  </FormGroup>
                  <br /><br />
                  <br /><br /><br /><br />
                </Grid>) : ''}

                {updateSlotsType === 1 ? (<Grid item xs={12} sm={12} md={12}>
                  <FormGroup>
                    <FormLabel>New Dropoff Date</FormLabel>
                    <DatePicker
                      selected={dropoffDate}
                      fullWidth
                      customInput={<OutlinedInput fullWidth />}
                      onChange={(date) => setDropoffDate(date)}
                      dateFormat="MMMM d, yyyy"
                    />
                  </FormGroup>

                  <FormGroup>
                    <FormLabel>New Dropoff Timeslot</FormLabel>
                    <FormControl variant="outlined" fullWidth>
                      <Select
                        value={dropoffTimeslot}
                        onChange={(e) => setDropoffTimeslot(e.target.value)}
                        IconComponent={KeyboardArrowDown}
                      >
                        {slots
                          .sort((a, b) => (a.startTime > b.startTime ? 1 : -1))
                          .map(function (slot, i) {
                            if (
                              dropoffDate != null &&
                              slot.dayId == dropoffDate.getDay() + 1 &&
                              (slot.deliveryType == 1 || slot.deliveryType == 2) && slot.isSubscription == 0
                            ) {
                              return (
                                <MenuItem value={slot.id}>
                                  {slot.startTime} - {slot.endTime} ({slot.driverByDriverId != null ? slot.driverByDriverId.fullNameEn : ''})
                                </MenuItem>
                              );
                            }
                          })}
                      </Select>
                    </FormControl>
                  </FormGroup>
                  <br /><br />
                  <br /><br /><br /><br />
                </Grid>) : ''}
              </Grid>
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setUpdateSlotsModal(false)}>Cancel</Button>
            <Button
              onClick={() => bulkUpdateSlotsAction()}
              classes={{
                root: classes.buttonContainedPurple100,
              }}
              variant="contained"
            >
              Update
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
    </>
  );
};

export default OrdersTable;
